<header>
  <h2 style="padding-right: 50px">Consulta Póliza Matrícula Abanca</h2>
  <span style="flex: 1 1 auto;"></span>
  <h2 id="btnCerrar" mat-flat-button style="margin-right: 20px; padding-left: 50px;" (click)="onClose()" >X</h2>
</header>
<mat-dialog-content style="padding-bottom: 20px;">
  <form [formGroup]="busquedaForm" (ngSubmit)="buscar()">
    <fieldset [disabled]="buscando">
      <label>
        Matrícula<br>
        <input type="text" matInput autofocus formControlName="matricula"><br>
      </label>
    </fieldset>
    <footer style="width: 20%">
      <button
          name="buscar"
          type="submit"
          style="width: 100%"
          formnovalidate
          mat-flat-button
          class="btnCCOscuro"
          [disabled]="! busquedaForm.valid || buscando"
          >Buscar</button>
    </footer>
  </form>

  <dl *ngIf="encontrado">
    <div>
      <dt>NIF</dt>
      <dd>{{ nif }}</dd>
    </div>

    <div>
      <dt>Nombre</dt>
      <dd>{{ nombre }}</dd>
    </div>

    <div>
      <dt>Apellidos</dt>
      <dd>{{ apellidos }}</dd>
    </div>

    <div>
      <dt>Dirección</dt>
      <dd>{{ direccion }}</dd>
    </div>

    <div>
      <dt>Código postal</dt>
      <dd>{{ codigoPostal }}</dd>
    </div>

    <div>
      <dt>Localidad</dt>
      <dd>{{ localidad }}</dd>
    </div>

    <div>
      <dt>Email</dt>
      <dd>{{ email }}</dd>
    </div>

    <div *ngFor="let telefono of telefonos; index as i">
      <dt>Telèfono&nbsp;{{ i + 1}}</dt>
      <dd>{{ telefono }}</dd>
    </div>

    <div>
      <dt>Póliza</dt>
      <dd>{{ poliza }}</dd>
    </div>

    <div>
      <dt>Marca</dt>
      <dd>{{ marca }}</dd>
    </div>

    <div>
      <dt>Modelo</dt>
      <dd>{{ modelo }}</dd>
    </div>

    <div>
      <dt>Fecha inicio cobertura</dt>
      <dd>{{ fechaInicioCobertura }}</dd>
    </div>

    <div>
      <dt>Fecha inicio contrato</dt>
      <dd>{{ fechaInicioContrato }}</dd>
    </div>

    <div>
      <dt>Fecha vencimiento contrato</dt>
      <dd>{{ fechaVencimientoContrato }}</dd>
    </div>

    <div>
      <dt>Siniestro</dt>
      <dd *ngIf="siniestro === ''; else tieneSiniestro"><dd>
      <ng-template #tieneSiniestro>{{ siniestro }}</ng-template>
    </div>
  </dl>
</mat-dialog-content>
<mat-dialog-actions align="center" style="margin-bottom: 20px; margin-top:5px;" *ngIf="encontrado">
  <button style="width: 30%;"  type="button" *ngIf="encontrado && siniestro === ''"  class="btnCCOscuro" mat-flat-button (click)="generarSiniestro()" [disabled]="buscando">Generar siniestro</button>
  <button style="width: 30%;"  *ngIf="encontrado" type="button" class="btnCCNewOscuro" mat-flat-button (click)="guardar()" [disabled]="buscando || !encontrado || !busquedaForm.valid">Grabar en hoja</button>
</mat-dialog-actions>
